var chunkToChildrenMap = {"7949":[8224,8224],"7248":[8224,9068],"2756":[8224,9068,1206],"4513":[8224,899],"3059":[8224,5448],"9726":[8224],"5012":[8224],"9116":[560],"7499":[8224],"1235":[8224],"3500":[8478,7949,1962],"1962":[8224],"4632":[8224]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};